export default "/images/0ec9198a1c8733cc38b89aa0b2982483.avif";